import React from "react";
import { AlertCircle, UserPlus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const ExistingMemberModal = ({ open, onOpenChange, existingMember, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 text-[#f59e0b]">
          <AlertCircle size={22} /> Membre déjà existant
        </DialogTitle>
      </DialogHeader>
      <div className="py-4">
        {existingMember?.member && (
          <>
            <p className="text-[#162d3d] mb-4">
              Un membre avec ces informations existe déjà dans le système :
            </p>
            <div className="bg-[#f4f7fa] rounded-lg p-4 mb-4">
              <p className="font-semibold text-[#162d3d]">
                {existingMember.member.first_name} {existingMember.member.last_name}
              </p>
              {existingMember.member.email && <p className="text-sm text-[#577083]">{existingMember.member.email}</p>}
              {existingMember.member.phone && <p className="text-sm text-[#577083]">{existingMember.member.phone}</p>}
              <p className="text-xs text-[#8fa4b5] mt-2">
                {existingMember.subscription_count > 0
                  ? `${existingMember.subscription_count} abonnement(s) existant(s)`
                  : "Aucun abonnement actuel"}
              </p>
            </div>
            <p className="text-[#577083]">
              Voulez-vous ajouter un <strong>nouvel abonnement</strong> à ce membre existant ?
            </p>
          </>
        )}
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="cancel-existing-member-btn">
          Annuler
        </Button>
        <Button onClick={onConfirm} className="bg-[#3899ec] hover:bg-[#2b7dca] text-white" data-testid="confirm-existing-member-btn">
          <UserPlus size={16} className="mr-2" /> Oui, ajouter l'abonnement
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
